import React, { useState, useEffect, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Button } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import CardInput from "../components/CardInput";
import AcceptedCards from "../components/AcceptedCards";
import getDaysInMonth from "date-fns/getDaysInMonth";

import { Context as WalletContext } from "../context/wallet.context";
import { Context as AuthContext } from "../context/auth.context";
import { Context as PortalContext } from "../context/portal.context";

const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

const generateYears = () => {
  var min = new Date().getFullYear();
  var max = min + 10;

  var options = [];

  for (var i = min; i <= max; i++) {
    options.push(i);
  }

  return options;
};

const AddCard = (props) => {
  const [accountNumber, setAccountNumber] = useState("");
  const [accountNumberValid, setAccountNumberValid] = useState(false);
  const [accountName, setAccountName] = useState("");
  const [nameError, setNameError] = useState(false);
  const [expMonth, setExpMonth] = useState("");
  const [expYear, setExpYear] = useState("");
  const [monthError, setMonthError] = useState(false);
  const [yearError, setYearError] = useState(false);
  const [isDefault, setIsDefault] = useState(false);
  const [autoPay, setAutoPay] = useState(false);

  const authState = useContext(AuthContext);
  const portalState = useContext(PortalContext);
  const { addPaymentMethod, updateDefaultPaymentMethod } = useContext(
    WalletContext
  );
  const walletState = useContext(WalletContext);

  let history = useHistory();

  let { op } = useParams();

  useEffect(() => {
    if (props.isUpdate) {
      const s = walletState.state.wallet[1];

      // console.log('wallet state is brad', walletState.state);
      setAccountName(s.name);
      setAccountNumber("**** **** **** " + s.acctLastFour);
      setExpMonth(s.secondary.slice(0, 2));
      setExpYear(s.secondary.slice(2, 7));
      setIsDefault(s.default === 0 ? false : true);
      setAutoPay(s.autoPay === 0 ? false : true);
    }
  }, []);
  
  const xLang = (string) => {
		return string
	}

  function enableButton() {
    //console.log(accountNumberValid, accountName, expMonth, expYear);
    if (
      accountNumberValid &&
      accountName !== "" &&
      expMonth !== "" &&
      expYear !== ""
    ) {
      return false;
    } else return true;
  }

  function validateExpDate(value, type) {
    //console.log(value, type);
    const month = type === "month" ? value : expMonth;
    const year = type === "year" ? value : expYear;

    //console.log(getDaysInMonth(new Date(year, month)));
    // Create a date object from month and year, on the first
    // of that month. You could check the end of the month
    // but that would be a little more complicated as you'd need
    // to know how many days are in that month.

    const expiryDate = new Date(
      year + "-" + month + `-${getDaysInMonth(new Date(year, month))}`
    );

    // You can compare date objects, this says if the expiryDate is
    // less than todays date, i.e. in the past. You could do <= if
    // you want to check whether they're the same date aswell.
    if (expiryDate < new Date()) {
      // Fails validation, show some error message to user
      console.log("fail");
      alert("Expiration date can't be before this month");
    } else {
      // Valid expiry
      console.log("pass");
      if (type === "month") {
        setExpMonth(value);
      } else {
        setExpYear(value);
      }
    }
  }

  function setExpDate(type, value) {
    //console.log(expYear);
    if (type === "month") {
      if (expYear !== "") {
        validateExpDate(value, "month");
      } else {
        setExpMonth(value);
      }
    } else {
      if (expMonth !== "") {
        validateExpDate(value, "year");
      } else {
        setExpYear(value);
      }
    }
  }

  function addCard() {
    //console.log(walletState.state.wallet);
    let needsBeDefault = Object.keys(walletState.state.wallet).length === 0;

    addPaymentMethod(
      {
        merchantID: authState.state.merchantID,
        customerID: authState.state.customerID,
        paymentMethod: "cc",
        bankAcctType: null,
        accountNumber,
        nameOnAccount: accountName,
        routingABA: null,
        expMonth,
        expYear,
        isDefault: needsBeDefault ? needsBeDefault : isDefault,
        autoPay: autoPay,
        op,
      },
      history
    );
  }

  return (
    <div
      style={{
        marginTop: 0,
        display: "flex",
        width: "100%",
        boxSizing: "border-box",
        flexDirection: "column",
        paddingBottom: "50px",
      }}
    >
      <AcceptedCards />
      <CardInput
        cardNumber={accountNumber}
        setCardNumber={setAccountNumber}
        setCardIsValid={setAccountNumberValid}
        cardIsValid={accountNumberValid}
      />
      <label
        style={{
          color: "#2f343b",
          display: "flex",
          alignSelf: "flex-start",
          marginBottom: 8,
        }}
      >
        <x-lang>Name on Card</x-lang>
      </label>
      <input
        type="text"
        value={accountName}
        onChange={(e) => {
          setAccountName(e.target.value);
        }}
        id="intellipay-card-name"
        style={{
          height: 40,

          borderRadius: 6,
          border: nameError ? "1px solid red" : "1px solid #d3dce0",
          boxShadow: "inset 0px 0px 0px 0px",
          outline: "none",
          borderStyle: "solid",
          boxSizing: "border-box",
          paddingLeft: 8,
          paddingRight: 8,
          fontSize: "1rem",
          fontWeight: 400,
          marginBottom: 25,
        }}
      />
      <label
        style={{
          color: "#2f343b",
          display: "flex",
          alignSelf: "flex-start",
          marginBottom: 8,
        }}
      >
        <x-lang>Expiration Date</x-lang>
      </label>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <select
          type="text"
          value={expMonth}
          onChange={(e) => {
            setExpDate("month", e.target.value);
            //console.log(expMonth);
          }}
          id="intellipay-card-name"
          style={{
            height: 40,
            width: 150,
            borderRadius: 6,
            border: monthError ? "1px solid red" : "1px solid #d3dce0",
            boxShadow: "inset 0px 0px 0px 0px",
            outline: "none",
            borderStyle: "solid",
            paddingLeft: 8,
            paddingRight: 8,
            fontSize: "1rem",
            fontWeight: 400,
            marginBottom: 25,
          }}
        >
          <option value="" disabled selected>
          {xLang("Month")}
          </option>
          {months.map((month) => {
            return <option key={month}>{month}</option>;
          })}
        </select>
        <select
          type="text"
          value={expYear}
          onChange={(e) => {
            setExpDate("year", e.target.value);
          }}
          id="intellipay-card-name"
          style={{
            height: 40,
            width: 200,
            marginLeft: 18,
            borderRadius: 6,
            border: yearError ? "1px solid red" : "1px solid #d3dce0",
            boxShadow: "inset 0px 0px 0px 0px",
            outline: "none",
            borderStyle: "solid",
            paddingLeft: 8,
            paddingRight: 20,
            fontSize: "1rem",
            fontWeight: 400,
            marginBottom: 25,
          }}
        >
          <option value="" disabled selected>
          {xLang("Year")}
          </option>
          {generateYears().map((year) => {
            return <option key={year}>{year}</option>;
          })}
        </select>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          justifyContent: "flex-start",
        }}
      >
        <div>
          <input
            type="checkbox"
            style={{ marginRight: 25 }}
            checked={isDefault}
            onChange={(e) => setIsDefault(e.target.checked)}
          ></input>
          <label><x-lang>Set as default</x-lang></label>
        </div>

        <Button
          variant={"contained"}
          disabled={enableButton()}
          color="secondary"
          style={{ width: "100%", height: 50, color: "white", marginTop: 25 }}
          onClick={() => addCard()}
        >
          <x-lang>Save</x-lang>
        </Button>
      </div>
      {/* {portalState.state.allowAutoPay ? (
        <>
          <Alert
            severity="warning"
            style={{
              marginBottom: 0,
              marginTop: 15,
              boxSizing: "border-box",
              width: "100%",
              textAlign: "left",
            }}
          >
            <b>IMPORTANT:</b> Enabling the “Auto Pay” feature will automatically
            trigger a charge to this card for the full amount of any invoice on
            its due date. This also means that any invoices that are past due
            will also be paid immediately.{" "}
          </Alert>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "flex-start",
              marginTop: 15,
            }}
          >
            <input
              type="checkbox"
              style={{ marginRight: 25 }}
              checked={autoPay}
              onChange={(e) => setAutoPay(e.target.checked)}
            ></input>
            <label>Auto Pay</label>
          </div>
        </>
      ) : null} */}
    </div>
  );
};

export default AddCard;
